exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cap-it-ui-alert-bar .warning-alert-bar .alert-bar-base{background-color:rgba(255,252,191,.9);color:inherit}.cap-it-ui-alert-bar .warning-alert-bar h3{font-weight:400;margin-bottom:0;margin-top:0}.cap-it-ui-alert-bar .warning-alert-bar .dismiss-btn path{stroke:#454545!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/shared/components/alert-bar/styles/warning-alert-bar.scss
// module id = 5235
// module chunks = 0